import React from "react";
import { Redirect } from "react-router-dom";
import { useAuthDispatch } from "../../components/AuthProvider";
import { USER_AUTH_KEY } from "../../utils/constants";

const SignOut = () => {
  const { clearSession } = useAuthDispatch();

  React.useEffect(() => {
    clearSession();
    window.localStorage.clear();
    if (window.localStorage.getItem("LOGIN_TYPE") === "MS-Email") {
      const sessionUser = window.localStorage.getItem(USER_AUTH_KEY);
      if (sessionUser) {
        window.location.replace(JSON.parse(sessionUser).logoutUrl);
      }
    }
  }, [clearSession]);

  return <Redirect to="/" />;
};

export default SignOut;
